import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-placeholder-object-add",
  "use": "icon-placeholder-object-add-usage",
  "viewBox": "0 0 32 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 24\" id=\"icon-placeholder-object-add\"><g id=\"icon-placeholder-object-add_fill\"><path d=\"M24.84,2l4.85,9.95L24.84,21.9H12.15a9.95,9.95,0,1,1,0-19.9H24.84m1.25-2H12.15a11.95,11.95,0,1,0,0,23.9H26.09l5.82-11.95L26.09,0Z\" /><polygon points=\"17.54 7.16 14.88 7.16 14.88 10.62 11.37 10.62 11.37 13.35 14.88 13.35 14.88 16.85 17.54 16.85 17.54 13.35 21.05 13.35 21.05 10.62 17.54 10.62 17.54 7.16\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol